import React from 'react';
import SubAppRenderer from './sub-app-renderer';

type Props = {
	componentsBeingDeleted: string[];
};

function ViewComponent(props: Props) {
	return (
		<div>
			{props.componentsBeingDeleted.map((id) => (
				<SubAppRenderer id={id} key={id} />
			))}
		</div>
	);
}

export default ViewComponent;
